import React from 'react'
import { Container, Divider, IconButton, InputAdornment, Checkbox, FormControlLabel } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { DatePicker } from '@material-ui/pickers'
import EventIcon from '@material-ui/icons/Event'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import NewFillButton from '../Core/NewFillButton'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import AdminApi from '../../api/admin.api'

export const BookRolloverAdmin = () => {
  const generatebookroll = async () => {
    const res = await awaitWithLoading(AdminApi.runBookRollover())

    if (res.ok) {
      EventEmitterService.dispatch(EventKey.ShowSuccess, {
        title: 'The BookRoll is generating now',
        body: 'You will see the bookroll in the drive in a couple of minutes',
      })
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  return (
    <Container className="margin-top-basic">
      <div className="text-promotion blue bold">Generate Bookroll Users</div>
      <Divider />
      <div>
        <div className="bold margin-bottom-small">Bookroll</div>
        <FlexView>
          <NewFillButton smallmargintop flat green onClick={() => generatebookroll()}>
            Generate Bookroll
          </NewFillButton>
        </FlexView>
      </div>
    </Container>
  )
}
